"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FeedbackProps_1 = require("../FeedbackProps");
require("./FeedbackMobile.css");
var icons = require("./../../../../styles/att-icons.css");
var styles = require("./FeedbackMobile.css");
var FeedbackMobile = /** @class */ (function (_super) {
    __extends(FeedbackMobile, _super);
    function FeedbackMobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeedbackMobile.prototype.render = function () {
        return (React.createElement("div", { className: this.constructFeedbackStyles(styles.feedbackContainer) },
            React.createElement("button", { className: this.constructFeedbackStyles(styles.feedbackButton), "data-test-id": this.props.testId, onClick: this.props.events.onClick },
                React.createElement("i", { className: [icons.attIcon, icons.attIconNotifications, styles.notificationIcon].join(' ') }),
                React.createElement("span", { className: styles.feedbackButtonText }, " " + this.props.data.text),
                React.createElement("i", { className: [icons.attIcon, icons.attIconStraightArrow, styles.arrowIcon].join(' ') }))));
    };
    FeedbackMobile.prototype.constructFeedbackStyles = function (primeStyle) {
        var feedbackStyles = [primeStyle];
        var options = this.props.options;
        if (options) {
            feedbackStyles = options.className ? [options.className] : feedbackStyles;
            if (options.theme === FeedbackProps_1.ThemeColor.DARK) {
                feedbackStyles.push(styles.dark);
            }
        }
        return feedbackStyles.join(' ');
    };
    return FeedbackMobile;
}(React.Component));
exports.default = FeedbackMobile;
//# sourceMappingURL=FeedbackMobile.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/Feedback/FeedbackMobile/FeedbackMobile.js
// module id = 1396
// module chunks = 8